import { render, staticRenderFns } from "./SafetycheckIndex.vue?vue&type=template&id=4e4075fd&scoped=true&"
import script from "./SafetycheckIndex.vue?vue&type=script&lang=js&"
export * from "./SafetycheckIndex.vue?vue&type=script&lang=js&"
import style0 from "./SafetycheckIndex.vue?vue&type=style&index=0&id=4e4075fd&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e4075fd",
  null
  
)

export default component.exports